import { directionalProperty, rem } from 'polished';
import styled, { css } from 'styled-components';

import { fontSizes, fontWeights } from '../../../../theme';
import { InputThemeVariantValues } from '../../types';

interface Props {
  $hasError: boolean;
  $isDisabled: boolean | undefined;
}

const getLabelColorStyles = ({
  variant,
  $hasError,
  $isDisabled,
}: Pick<Props, '$hasError' | '$isDisabled'> & {
  variant: InputThemeVariantValues;
}) => {
  if ($hasError) return variant['label-error'];
  if ($isDisabled) return variant['label-disabled'];

  return variant['label-default'];
};

export const InputLabelRoot = styled.span.attrs({
  role: 'alert',
})<Props>`
  ${({ theme, $isDisabled, $hasError }) => {
    /**
     * @note
     * Label in design is only defined for `big` variant,
     * and for `small` there isn't any label,
     * so for now we just use values from big variant
     */
    const variant = theme.components.Input.regular.big;

    return css`
      box-sizing: border-box;
      display: flex;
      align-items: center;
      gap: ${variant['label-inside']};
      ${directionalProperty(
        'padding',
        variant['label-up-padding'],
        variant['horizontal-padding'],
        variant['label-down-padding'],
        variant['horizontal-padding'],
      )};

      color: ${getLabelColorStyles({ $isDisabled, $hasError, variant })};
      font-weight: ${fontWeights.mediumLarge};
      font-size: ${fontSizes.m};
      line-height: ${rem(18)};

      svg {
        fill: ${$hasError
          ? variant['label-icon-error']
          : variant['label-icon-default']};
        width: ${rem(18)};
        height: ${rem(18)};
        flex-grow: 0;
        flex-shrink: 0;
      }
    `;
  }}
`;

export const InputLabelText = styled.span`
  box-sizing: border-box;
  margin-top: ${rem(6)};
  overflow: hidden;
  text-overflow: ellipsis;
`;
